/* Progressive enhancement: the garment and buying controls work without motion. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const section = entry.target;
      section.dataset.visible = entry.isIntersecting ? 'true' : 'false';
      section.dataset.motion = entry.isIntersecting && section.dataset.paused !== 'true' && !reduced.matches ? 'running' : 'paused';
    });
  }, {threshold: 0.12}) : null;
  function initialize() {
    document.querySelectorAll('[data-ee-lineup]').forEach(lineup => {
      if (lineup.dataset.ready) return;
      lineup.dataset.ready = 'true';
      const tabs = Array.from(lineup.querySelectorAll('[data-ee-tab]'));
      const panels = Array.from(lineup.querySelectorAll('[data-ee-panel]'));
      const select = tab => {
        tabs.forEach(item => {const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;});
        panels.forEach(panel => {panel.hidden = panel.dataset.eePanel !== tab.dataset.eeTab; if (panel.hidden) panel.dataset.motion = 'paused';});
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); select(tabs[next]); tabs[next].focus();
        });
      });
    });
    document.querySelectorAll('[data-ee-study]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      section.dataset.view = 'front';
      section.dataset.paused = reduced.matches ? 'true' : 'false';
      const update = () => {
        const paused = section.dataset.paused === 'true' || reduced.matches;
        section.dataset.motion = !paused && section.dataset.visible !== 'false' ? 'running' : 'paused';
      };
      section.querySelectorAll('[data-ee-view]').forEach(button => button.addEventListener('click', () => {
        section.dataset.view = button.dataset.eeView;
        section.querySelectorAll('[data-ee-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      reduced.addEventListener('change', update);
      if (observer) observer.observe(section);
      update();
    });
  }
  initialize();
  document.addEventListener('DOMContentLoaded', initialize, {once:true});
  document.addEventListener('shopify:section:load', initialize);
})();
